
import Microphone from 'vue-material-design-icons/Microphone.vue'
import MicrophoneOff from 'vue-material-design-icons/MicrophoneOff.vue'

export default {
	name: 'VolumeIndicator',

	components: {
		Microphone,
		MicrophoneOff,
	},

	props: {
		audioPreviewAvailable: {
			type: Boolean,
			required: true,
		},

		audioEnabled: {
			type: Boolean,
			required: true,
		},

		currentVolume: {
			type: Number,
			required: true,
		},

		volumeThreshold: {
			type: Number,
			required: true,
		},

		overloadLimit: {
			type: Number,
			default: -25,
		},

		size: {
			type: Number,
			default: 20,
		},

		primaryColor: {
			type: String,
			default: undefined,
		},

		overlayColor: {
			type: String,
			default: undefined,
		},

		overlayMutedColor: {
			type: String,
			default: undefined,
		},
	},

	computed: {
		iconOffsetBottom() {
			return this.size / 8
		},

		iconPrimaryHeight() {
			return this.audioPreviewAvailable
				? this.size - this.iconOffsetBottom - this.currentVolumeIndicatorHeight
				: this.size
		},

		iconOverlayHeight() {
			return this.iconOffsetBottom / 2 + this.currentVolumeIndicatorHeight
		},

		hasOverload() {
			return this.audioPreviewAvailable && this.currentVolumeIndicatorHeight === this.size - this.iconOffsetBottom
		},

		currentVolumeIndicatorHeight() {
			if (!this.audioPreviewAvailable) {
				return 0
			}

			// WebRTC volume goes from -100 (silence) to 0 (loudest sound in the
			// system); for the volume indicator only sounds above the threshold
			// are taken into account.
			if (this.currentVolume < this.volumeThreshold) {
				return 0
			}

			return (this.size - this.iconOffsetBottom) * this.computeVolumeLevel()
		},
	},

	methods: {
		computeVolumeLevel() {
			const computedLevel = (this.volumeThreshold - this.currentVolume) / (this.volumeThreshold - this.overloadLimit)

			return Math.min(1, Math.max(0, computedLevel))
		},
	},
}
